import {crossfade} from 'svelte/transition';

const [send, receive] = crossfade({
  duration: d => Math.sqrt(d * 150),
  fallback(node, params) {
    const style = getComputedStyle(node);
    const transform = style.transform === 'none' ? '' : style.transform;

    return {
      ...params,
      duration: 450,
      css: t => `
        transform: ${transform} scale(${t});
        opacity: ${t}
      `
    };
  }
});

export {send, receive};
